import { makeRequest, toCorrectFormDataValue, } from '@/js/libs/api';
import * as Types from './types';
import { encodeBody, fromDateType as fromDate, toDateType as toDate, fromDateTimeType as fromDateTime, toDateTimeUnixType as toDateTime, } from '@/js/libs/api-helpers';
export { fromDate, toDate, fromDateTime, toDateTime };
export const getCampaigns = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.state === undefined) {
        throw new Error('Missing required parameter: state');
    }
    const path = '/api/ws-invoices/campaigns';
    const pathInternal = '/api/campaigns';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.state !== undefined) {
        urlParams.append('state', params.state.toString());
    }
    {
        const value = queryDefaults === false ? params.companyId : (params.companyId ?? queryDefaults?.['companyId']);
        if (value !== undefined) {
            urlParams.append('companyId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.searchFilter : (params.searchFilter ?? queryDefaults?.['searchFilter']);
        if (value !== undefined) {
            urlParams.append('searchFilter', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaigns.paramsOrder = [{ type: 'parameters' }];
/** Returns invoice emails by campaign */ export const getEmailsByCampaign = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-invoices/campaigns/{campaignId}/emails'.replaceAll('{campaignId}', () => encodeURIComponent(String(params.campaignId)));
    const pathInternal = '/api/campaigns/{campaignId}/emails'.replaceAll('{campaignId}', () => encodeURIComponent(String(params.campaignId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getEmailsByCampaign.paramsOrder = [{ type: 'parameters' }];
export const getInvoiceStateForSingleCampaign = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-invoices/campaign/invoice-state/{campaignId}'.replaceAll('{campaignId}', () => encodeURIComponent(String(params.campaignId)));
    const pathInternal = '/api/campaign/invoice-state/{campaignId}'.replaceAll('{campaignId}', () => encodeURIComponent(String(params.campaignId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getInvoiceStateForSingleCampaign.paramsOrder = [{ type: 'parameters' }];
export const getInvoiceStateForMultipleCampaigns = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignIds === undefined) {
        throw new Error('Missing required body: campaignIds');
    }
    const path = '/api/ws-invoices/campaign/invoice-state-by-ids';
    const pathInternal = '/api/campaign/invoice-state-by-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignIds !== undefined) {
        body = params.campaignIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getInvoiceStateForMultipleCampaigns.paramsOrder = [{ type: 'body', paramName: 'campaignIds' }];
export const getInvoiceStateForMultipleCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignPositionIds === undefined) {
        throw new Error('Missing required body: campaignPositionIds');
    }
    const path = '/api/ws-invoices/campaign-position/invoice-state-by-ids';
    const pathInternal = '/api/campaign-position/invoice-state-by-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignPositionIds !== undefined) {
        body = params.campaignPositionIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getInvoiceStateForMultipleCampaignPositions.paramsOrder = [{ type: 'body', paramName: 'campaignPositionIds' }];
export const getSBInvoices = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-invoices/invoices/self-booked';
    const pathInternal = '/api/invoices/self-booked';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSBInvoices.paramsOrder = [{ type: 'parameters' }];
export const getInvoices = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-invoices/invoices';
    const pathInternal = '/api/invoices';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.invoiceState : (params.invoiceState ?? queryDefaults?.['invoiceState']);
        if (value !== undefined) {
            urlParams.append('invoiceState', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.companyId : (params.companyId ?? queryDefaults?.['companyId']);
        if (value !== undefined) {
            urlParams.append('companyId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.entityId : (params.entityId ?? queryDefaults?.['entityId']);
        if (value !== undefined) {
            urlParams.append('entityId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.searchFilter : (params.searchFilter ?? queryDefaults?.['searchFilter']);
        if (value !== undefined) {
            urlParams.append('searchFilter', value.toString());
        }
    }
    {
        const value = queryDefaults === false
            ? params.campaignStartDateFrom
            : (params.campaignStartDateFrom ?? queryDefaults?.['campaignStartDateFrom']);
        if (value !== undefined) {
            urlParams.append('campaignStartDateFrom', value.toString());
        }
    }
    {
        const value = queryDefaults === false
            ? params.campaignStartDateTo
            : (params.campaignStartDateTo ?? queryDefaults?.['campaignStartDateTo']);
        if (value !== undefined) {
            urlParams.append('campaignStartDateTo', value.toString());
        }
    }
    {
        const value = queryDefaults === false
            ? params.campaignCloseDateFrom
            : (params.campaignCloseDateFrom ?? queryDefaults?.['campaignCloseDateFrom']);
        if (value !== undefined) {
            urlParams.append('campaignCloseDateFrom', value.toString());
        }
    }
    {
        const value = queryDefaults === false
            ? params.campaignCloseDateTo
            : (params.campaignCloseDateTo ?? queryDefaults?.['campaignCloseDateTo']);
        if (value !== undefined) {
            urlParams.append('campaignCloseDateTo', value.toString());
        }
    }
    {
        const value = queryDefaults === false
            ? params.invoicingAccountId
            : (params.invoicingAccountId ?? queryDefaults?.['invoicingAccountId']);
        if (value !== undefined) {
            urlParams.append('invoicingAccountId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.ownerId : (params.ownerId ?? queryDefaults?.['ownerId']);
        if (value !== undefined) {
            urlParams.append('ownerId', value.toString());
        }
    }
    {
        const value = queryDefaults === false
            ? params.campaignPositionType
            : (params.campaignPositionType ?? queryDefaults?.['campaignPositionType']);
        if (value !== undefined) {
            urlParams.append('campaignPositionType', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.adMediumName : (params.adMediumName ?? queryDefaults?.['adMediumName']);
        if (value !== undefined) {
            urlParams.append('adMediumName', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.unpaidOnly : (params.unpaidOnly ?? queryDefaults?.['unpaidOnly']);
        if (value !== undefined) {
            urlParams.append('unpaidOnly', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.currency : (params.currency ?? queryDefaults?.['currency']);
        if (value !== undefined) {
            urlParams.append('currency', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.languageCode : (params.languageCode ?? queryDefaults?.['languageCode']);
        if (value !== undefined) {
            urlParams.append('languageCode', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getInvoices.paramsOrder = [{ type: 'parameters' }];
export const getInactiveInvoicesInReminderState = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-invoices/invoices/reminder-state/inactive';
    const pathInternal = '/api/invoices/reminder-state/inactive';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.entityId : (params.entityId ?? queryDefaults?.['entityId']);
        if (value !== undefined) {
            urlParams.append('entityId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.searchFilter : (params.searchFilter ?? queryDefaults?.['searchFilter']);
        if (value !== undefined) {
            urlParams.append('searchFilter', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getInactiveInvoicesInReminderState.paramsOrder = [{ type: 'parameters' }];
export const getInvoiceById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    const pathInternal = '/api/invoices/{invoiceId}'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getInvoiceById.paramsOrder = [{ type: 'parameters' }];
export const getInvoiceByCustomRangeId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.customRangeId === undefined) {
        throw new Error('Missing required parameter: customRangeId');
    }
    const path = '/api/ws-invoices/invoices/by-custom-range/{customRangeId}'.replaceAll('{customRangeId}', () => encodeURIComponent(String(params.customRangeId)));
    const pathInternal = '/api/invoices/by-custom-range/{customRangeId}'.replaceAll('{customRangeId}', () => encodeURIComponent(String(params.customRangeId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getInvoiceByCustomRangeId.paramsOrder = [{ type: 'parameters' }];
export const getUnpaidInvoicesAmount = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    const path = '/api/ws-invoices/unpaid-amount';
    const pathInternal = '/api/unpaid-amount';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountId !== undefined) {
        urlParams.append('accountId', params.accountId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getUnpaidInvoicesAmount.paramsOrder = [{ type: 'parameters' }];
/** Returns invoicing campaign data by ws-orders campaign ID. A campaign must be registered in ws-invoices to have invoicing capabilities. The response contains entityId (internal ws-invoices identifier) and invoicing configuration. Returns 200 with null body if the campaign is not registered. */ export const getCampaignById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.entityId === undefined) {
        throw new Error('Missing required parameter: entityId');
    }
    const path = '/api/ws-invoices/campaigns/{entityId}'.replaceAll('{entityId}', () => encodeURIComponent(String(params.entityId)));
    const pathInternal = '/api/campaigns/{entityId}'.replaceAll('{entityId}', () => encodeURIComponent(String(params.entityId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignById.paramsOrder = [{ type: 'parameters' }];
export const createManualInvoice = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-invoices/campaigns/{campaignId}/invoices/create'.replaceAll('{campaignId}', () => encodeURIComponent(String(params.campaignId)));
    const pathInternal = '/api/campaigns/{campaignId}/invoices/create'.replaceAll('{campaignId}', () => encodeURIComponent(String(params.campaignId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createManualInvoice.paramsOrder = [{ type: 'parameters' }];
export const approveInvoice = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-invoices/invoices/approve/{invoiceId}'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    const pathInternal = '/api/invoices/approve/{invoiceId}'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
approveInvoice.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const resendPingenInvoice = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}/pingen/resend'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    const pathInternal = '/api/invoices/{invoiceId}/pingen/resend'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'text/plain';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'text',
        requestType: 'json',
    });
};
resendPingenInvoice.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const resendDigitalInvoice = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}/digital/resend'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    const pathInternal = '/api/invoices/{invoiceId}/digital/resend'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.orientationType : (params.orientationType ?? queryDefaults?.['orientationType']);
        if (value !== undefined) {
            urlParams.append('orientationType', value.toString());
        }
    }
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'text/plain';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
resendDigitalInvoice.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const isFileSentInPingen = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.fileName === undefined) {
        throw new Error('Missing required parameter: fileName');
    }
    const path = '/api/ws-invoices/invoices/pingen/sent/check';
    const pathInternal = '/api/invoices/pingen/sent/check';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.fileName !== undefined) {
        urlParams.append('fileName', params.fileName.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
isFileSentInPingen.paramsOrder = [{ type: 'parameters' }];
export const cancelInvoice = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}/cancel'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    const pathInternal = '/api/invoices/{invoiceId}/cancel'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.invoiceCancelForm !== undefined) {
        body = params.invoiceCancelForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
cancelInvoice.paramsOrder = [{ type: 'body', paramName: 'invoiceCancelForm' }, { type: 'parameters' }];
export const editInvoiceCancellationDate = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}/cancellation-date'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    const pathInternal = '/api/invoices/{invoiceId}/cancellation-date'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.invoiceCancelForm !== undefined) {
        body = params.invoiceCancelForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
editInvoiceCancellationDate.paramsOrder = [
    { type: 'body', paramName: 'invoiceCancelForm' },
    { type: 'parameters' },
];
export const reopenInvoice = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}/reopen'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    const pathInternal = '/api/invoices/{invoiceId}/reopen'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
reopenInvoice.paramsOrder = [{ type: 'parameters' }];
export const cancelAndReopenInvoice = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}/cancel-and-reopen'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    const pathInternal = '/api/invoices/{invoiceId}/cancel-and-reopen'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.invoiceCancelForm !== undefined) {
        body = params.invoiceCancelForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
cancelAndReopenInvoice.paramsOrder = [
    { type: 'body', paramName: 'invoiceCancelForm' },
    { type: 'parameters' },
];
export const paidInvoice = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}/paid'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    const pathInternal = '/api/invoices/{invoiceId}/paid'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
paidInvoice.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const revertPaidInvoice = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}/revert-paid'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    const pathInternal = '/api/invoices/{invoiceId}/revert-paid'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
revertPaidInvoice.paramsOrder = [{ type: 'parameters' }];
export const archiveInvoice = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}/archive'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    const pathInternal = '/api/invoices/{invoiceId}/archive'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
archiveInvoice.paramsOrder = [{ type: 'parameters' }];
export const restoreInvoice = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}/restore'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    const pathInternal = '/api/invoices/{invoiceId}/restore'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
restoreInvoice.paramsOrder = [{ type: 'parameters' }];
export const remindPersonallyForInvoice = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}/remind-personally'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    const pathInternal = '/api/invoices/{invoiceId}/remind-personally'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
remindPersonallyForInvoice.paramsOrder = [{ type: 'parameters' }];
export const changeInvoiceStateBack = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    if (params.previousInvoiceId === undefined) {
        throw new Error('Missing required parameter: previousInvoiceId');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}/change-state-back'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    const pathInternal = '/api/invoices/{invoiceId}/change-state-back'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.previousInvoiceId !== undefined) {
        urlParams.append('previousInvoiceId', params.previousInvoiceId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
changeInvoiceStateBack.paramsOrder = [{ type: 'parameters' }];
export const moveToCollectionReminderInvoiceState = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}/collection-reminder'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    const pathInternal = '/api/invoices/{invoiceId}/collection-reminder'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
moveToCollectionReminderInvoiceState.paramsOrder = [{ type: 'parameters' }];
export const moveToBadDebtInvoiceState = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}/bad-debt'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    const pathInternal = '/api/invoices/{invoiceId}/bad-debt'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
moveToBadDebtInvoiceState.paramsOrder = [{ type: 'parameters' }];
export const revertBadDebtInvoiceState = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}/revert-bad-debt'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    const pathInternal = '/api/invoices/{invoiceId}/revert-bad-debt'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
revertBadDebtInvoiceState.paramsOrder = [{ type: 'parameters' }];
/** Returns emails by invoice id */ export const getEmailsByInvoice = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}/emails'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    const pathInternal = '/api/invoices/{invoiceId}/emails'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getEmailsByInvoice.paramsOrder = [{ type: 'parameters' }];
/** Edits the invoice */ export const editInvoice = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    if (params.invoice === undefined) {
        throw new Error('Missing required body: invoice');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}/edit'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    const pathInternal = '/api/invoices/{invoiceId}/edit'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.invoice !== undefined) {
        body = params.invoice;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
editInvoice.paramsOrder = [{ type: 'body', paramName: 'invoice' }, { type: 'parameters' }];
export const editReminder = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    if (params.invoice === undefined) {
        throw new Error('Missing required body: invoice');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}/edit-reminder'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    const pathInternal = '/api/invoices/{invoiceId}/edit-reminder'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.invoice !== undefined) {
        body = params.invoice;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
editReminder.paramsOrder = [{ type: 'body', paramName: 'invoice' }, { type: 'parameters' }];
export const getChargedInvoiceIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.entityIds === undefined) {
        throw new Error('Missing required body: entityIds');
    }
    const path = '/api/ws-invoices/campaigns/by-entity-ids';
    const pathInternal = '/api/campaigns/by-entity-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.entityIds !== undefined) {
        body = params.entityIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getChargedInvoiceIds.paramsOrder = [{ type: 'body', paramName: 'entityIds' }];
export const exportInvoices = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-invoices/invoices/export';
    const pathInternal = '/api/invoices/export';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
exportInvoices.paramsOrder = [];
export const exportRevenueRecognition = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-invoices/invoices/export-revenue-recognition';
    const pathInternal = '/api/invoices/export-revenue-recognition';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
exportRevenueRecognition.paramsOrder = [];
export const retransmitInvoice = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}/retransmit-to-sap'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    const pathInternal = '/api/invoices/{invoiceId}/retransmit-to-sap'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
retransmitInvoice.paramsOrder = [{ type: 'parameters' }];
export const pushInvoiceToBexio = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    if (params.invoicePositionIds === undefined) {
        throw new Error('Missing required body: invoicePositionIds');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}/bexio/push'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    const pathInternal = '/api/invoices/{invoiceId}/bexio/push'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.invoicePositionIds !== undefined) {
        body = params.invoicePositionIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
pushInvoiceToBexio.paramsOrder = [{ type: 'body', paramName: 'invoicePositionIds' }, { type: 'parameters' }];
/** Download invoice */ export const downloadInvoice = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}/download'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    const pathInternal = '/api/invoices/{invoiceId}/download'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.withCoverSheet : (params.withCoverSheet ?? queryDefaults?.['withCoverSheet']);
        if (value !== undefined) {
            urlParams.append('withCoverSheet', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.orientationType : (params.orientationType ?? queryDefaults?.['orientationType']);
        if (value !== undefined) {
            urlParams.append('orientationType', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: { 200: 'json', 204: 'json' },
        requestType: 'json',
    });
};
downloadInvoice.paramsOrder = [{ type: 'parameters' }];
/** Download invoice preview */ export const downloadInvoicePreview = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    if (params.invoicePositionIds === undefined) {
        throw new Error('Missing required body: invoicePositionIds');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}/preview/download'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    const pathInternal = '/api/invoices/{invoiceId}/preview/download'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.invoicePositionIds !== undefined) {
        body = params.invoicePositionIds;
    }
    {
        const value = queryDefaults === false ? params.orientationType : (params.orientationType ?? queryDefaults?.['orientationType']);
        if (value !== undefined) {
            urlParams.append('orientationType', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
downloadInvoicePreview.paramsOrder = [
    { type: 'body', paramName: 'invoicePositionIds' },
    { type: 'parameters' },
];
/** Generate invoice pdf */ export const generateInvoice = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    const path = '/api/ws-invoices/invoices/{invoiceId}/generate'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    const pathInternal = '/api/invoices/{invoiceId}/generate'.replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.orientationType : (params.orientationType ?? queryDefaults?.['orientationType']);
        if (value !== undefined) {
            urlParams.append('orientationType', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
generateInvoice.paramsOrder = [{ type: 'parameters' }];
/** Returns email body text */ export const getDefaultEmailText = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.invoiceEmailDto === undefined) {
        throw new Error('Missing required body: invoiceEmailDto');
    }
    const path = '/api/ws-invoices/campaign/{campaignId}/email-text'.replaceAll('{campaignId}', () => encodeURIComponent(String(params.campaignId)));
    const pathInternal = '/api/campaign/{campaignId}/email-text'.replaceAll('{campaignId}', () => encodeURIComponent(String(params.campaignId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.invoiceEmailDto !== undefined) {
        body = params.invoiceEmailDto;
    }
    const headers = {};
    headers['Accept'] = 'text/html';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'text',
        requestType: 'json',
    });
};
getDefaultEmailText.paramsOrder = [{ type: 'body', paramName: 'invoiceEmailDto' }, { type: 'parameters' }];
/** Returns cancellation invoice email body text */ export const getDefaultCancelInvoiceEmailText = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.invoiceEmailDto === undefined) {
        throw new Error('Missing required body: invoiceEmailDto');
    }
    const path = '/api/ws-invoices/campaign/{campaignId}/cancel-invoice-email-text'.replaceAll('{campaignId}', () => encodeURIComponent(String(params.campaignId)));
    const pathInternal = '/api/campaign/{campaignId}/cancel-invoice-email-text'.replaceAll('{campaignId}', () => encodeURIComponent(String(params.campaignId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.invoiceEmailDto !== undefined) {
        body = params.invoiceEmailDto;
    }
    const headers = {};
    headers['Accept'] = 'text/html';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'text',
        requestType: 'json',
    });
};
getDefaultCancelInvoiceEmailText.paramsOrder = [
    { type: 'body', paramName: 'invoiceEmailDto' },
    { type: 'parameters' },
];
/** Returns default postal address text */ export const getDefaultPostalAddress = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-invoices/campaign/{campaignId}/postal-address'.replaceAll('{campaignId}', () => encodeURIComponent(String(params.campaignId)));
    const pathInternal = '/api/campaign/{campaignId}/postal-address'.replaceAll('{campaignId}', () => encodeURIComponent(String(params.campaignId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'text/plain';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'text',
        requestType: 'json',
    });
};
getDefaultPostalAddress.paramsOrder = [{ type: 'parameters' }];
/** Get not paid amount n4 accross all sb campaigns */ export const getNotPaidSBAmount = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-invoices/campaigns/self-booked/notPaidAmount';
    const pathInternal = '/api/campaigns/self-booked/notPaidAmount';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getNotPaidSBAmount.paramsOrder = [];
export const retransmitInvoices = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.invoiceIds === undefined) {
        throw new Error('Missing required body: invoiceIds');
    }
    const path = '/api/ws-invoices/campaigns/{campaignId}/retransmit-invoices'.replaceAll('{campaignId}', () => encodeURIComponent(String(params.campaignId)));
    const pathInternal = '/api/campaigns/{campaignId}/retransmit-invoices'.replaceAll('{campaignId}', () => encodeURIComponent(String(params.campaignId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.invoiceIds !== undefined) {
        body = params.invoiceIds;
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
retransmitInvoices.paramsOrder = [{ type: 'body', paramName: 'invoiceIds' }, { type: 'parameters' }];
/** Checks credit info for the given account and positions */ export const checkCredit = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-invoices/credit/check';
    const pathInternal = '/api/credit/check';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
checkCredit.paramsOrder = [{ type: 'body', paramName: 'form' }];
/** Get credit information by accounts */ export const getCreditInfoByAccountIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.accountIds === undefined) {
        throw new Error('Missing required body: accountIds');
    }
    const path = '/api/ws-invoices/credit/accounts';
    const pathInternal = '/api/credit/accounts';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.currency : (params.currency ?? queryDefaults?.['currency']);
        if (value !== undefined) {
            urlParams.append('currency', value.toString());
        }
    }
    if (params.accountIds !== undefined) {
        body = params.accountIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCreditInfoByAccountIds.paramsOrder = [{ type: 'body', paramName: 'accountIds' }, { type: 'parameters' }];
/** Replace old account id with new one. */ export const replaceAccountId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    if (params.newAccountId === undefined) {
        throw new Error('Missing required parameter: newAccountId');
    }
    const path = '/api/ws-invoices/accounts/replace-account-id';
    const pathInternal = '/api/accounts/replace-account-id';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountId !== undefined) {
        urlParams.append('accountId', params.accountId.toString());
    }
    if (params.newAccountId !== undefined) {
        urlParams.append('newAccountId', params.newAccountId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
replaceAccountId.paramsOrder = [{ type: 'parameters' }];
/** Get payments */ export const getPayments = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.paymentStatus === undefined) {
        throw new Error('Missing required parameter: paymentStatus');
    }
    const path = '/api/ws-invoices/payments/{paymentStatus}'.replaceAll('{paymentStatus}', () => encodeURIComponent(String(params.paymentStatus)));
    const pathInternal = '/api/payments/{paymentStatus}'.replaceAll('{paymentStatus}', () => encodeURIComponent(String(params.paymentStatus)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.searchFilter : (params.searchFilter ?? queryDefaults?.['searchFilter']);
        if (value !== undefined) {
            urlParams.append('searchFilter', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.dateFrom : (params.dateFrom ?? queryDefaults?.['dateFrom']);
        if (value !== undefined) {
            urlParams.append('dateFrom', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.dateTo : (params.dateTo ?? queryDefaults?.['dateTo']);
        if (value !== undefined) {
            urlParams.append('dateTo', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.isCredit : (params.isCredit ?? queryDefaults?.['isCredit']);
        if (value !== undefined) {
            urlParams.append('isCredit', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPayments.paramsOrder = [{ type: 'parameters' }];
/** Upload payment file */ export const uploadAndProcessPaymentFile = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-invoices/payments/upload-and-process-file';
    const pathInternal = '/api/payments/upload-and-process-file';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.content !== undefined) {
        formData.append('content', toCorrectFormDataValue(params.content));
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'multipart/form-data';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: formData,
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'form-data',
    });
};
uploadAndProcessPaymentFile.paramsOrder = [{ type: 'formData' }];
export const addAccountToPayment = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.paymentId === undefined) {
        throw new Error('Missing required parameter: paymentId');
    }
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    const path = '/api/ws-invoices/payments/{paymentId}/add-account/{accountId}'
        .replaceAll('{paymentId}', () => encodeURIComponent(String(params.paymentId)))
        .replaceAll('{accountId}', () => encodeURIComponent(String(params.accountId)));
    const pathInternal = '/api/payments/{paymentId}/add-account/{accountId}'
        .replaceAll('{paymentId}', () => encodeURIComponent(String(params.paymentId)))
        .replaceAll('{accountId}', () => encodeURIComponent(String(params.accountId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
addAccountToPayment.paramsOrder = [{ type: 'parameters' }];
export const removeAccountFromPayment = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.paymentId === undefined) {
        throw new Error('Missing required parameter: paymentId');
    }
    const path = '/api/ws-invoices/payments/{paymentId}/remove-account'.replaceAll('{paymentId}', () => encodeURIComponent(String(params.paymentId)));
    const pathInternal = '/api/payments/{paymentId}/remove-account'.replaceAll('{paymentId}', () => encodeURIComponent(String(params.paymentId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
removeAccountFromPayment.paramsOrder = [{ type: 'parameters' }];
export const addInvoiceToPayment = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.paymentId === undefined) {
        throw new Error('Missing required parameter: paymentId');
    }
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    const path = '/api/ws-invoices/payments/{paymentId}/add-invoice/{invoiceId}'
        .replaceAll('{paymentId}', () => encodeURIComponent(String(params.paymentId)))
        .replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    const pathInternal = '/api/payments/{paymentId}/add-invoice/{invoiceId}'
        .replaceAll('{paymentId}', () => encodeURIComponent(String(params.paymentId)))
        .replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
addInvoiceToPayment.paramsOrder = [{ type: 'parameters' }];
export const removeInvoiceFromPayment = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.paymentId === undefined) {
        throw new Error('Missing required parameter: paymentId');
    }
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    const path = '/api/ws-invoices/payments/{paymentId}/remove-invoice/{invoiceId}'
        .replaceAll('{paymentId}', () => encodeURIComponent(String(params.paymentId)))
        .replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    const pathInternal = '/api/payments/{paymentId}/remove-invoice/{invoiceId}'
        .replaceAll('{paymentId}', () => encodeURIComponent(String(params.paymentId)))
        .replaceAll('{invoiceId}', () => encodeURIComponent(String(params.invoiceId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
removeInvoiceFromPayment.paramsOrder = [{ type: 'parameters' }];
export const addSelfbookingInvoiceToPayment = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.paymentId === undefined) {
        throw new Error('Missing required parameter: paymentId');
    }
    if (params.selfbookingInvoiceId === undefined) {
        throw new Error('Missing required parameter: selfbookingInvoiceId');
    }
    const path = '/api/ws-invoices/payments/{paymentId}/add-selfbooking-invoice/{selfbookingInvoiceId}'
        .replaceAll('{paymentId}', () => encodeURIComponent(String(params.paymentId)))
        .replaceAll('{selfbookingInvoiceId}', () => encodeURIComponent(String(params.selfbookingInvoiceId)));
    const pathInternal = '/api/payments/{paymentId}/add-selfbooking-invoice/{selfbookingInvoiceId}'
        .replaceAll('{paymentId}', () => encodeURIComponent(String(params.paymentId)))
        .replaceAll('{selfbookingInvoiceId}', () => encodeURIComponent(String(params.selfbookingInvoiceId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
addSelfbookingInvoiceToPayment.paramsOrder = [{ type: 'parameters' }];
export const removeSelfbookingInvoiceFromPayment = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.paymentId === undefined) {
        throw new Error('Missing required parameter: paymentId');
    }
    if (params.selfbookingInvoiceId === undefined) {
        throw new Error('Missing required parameter: selfbookingInvoiceId');
    }
    const path = '/api/ws-invoices/payments/{paymentId}/remove-selfbooking-invoice/{selfbookingInvoiceId}'
        .replaceAll('{paymentId}', () => encodeURIComponent(String(params.paymentId)))
        .replaceAll('{selfbookingInvoiceId}', () => encodeURIComponent(String(params.selfbookingInvoiceId)));
    const pathInternal = '/api/payments/{paymentId}/remove-selfbooking-invoice/{selfbookingInvoiceId}'
        .replaceAll('{paymentId}', () => encodeURIComponent(String(params.paymentId)))
        .replaceAll('{selfbookingInvoiceId}', () => encodeURIComponent(String(params.selfbookingInvoiceId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
removeSelfbookingInvoiceFromPayment.paramsOrder = [{ type: 'parameters' }];
export const markSelfbookingPaymentAsOpen = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.paymentId === undefined) {
        throw new Error('Missing required parameter: paymentId');
    }
    const path = '/api/ws-invoices/payments/{paymentId}/mark-selfbooking-as-open'.replaceAll('{paymentId}', () => encodeURIComponent(String(params.paymentId)));
    const pathInternal = '/api/payments/{paymentId}/mark-selfbooking-as-open'.replaceAll('{paymentId}', () => encodeURIComponent(String(params.paymentId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
markSelfbookingPaymentAsOpen.paramsOrder = [{ type: 'parameters' }];
/** Returns ws-invoices invoices combined with ws-selfbooking invoices */ export const getInvoicesIncludingSelfbooking = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-invoices/invoices/including-selfbooking';
    const pathInternal = '/api/invoices/including-selfbooking';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.searchFilter : (params.searchFilter ?? queryDefaults?.['searchFilter']);
        if (value !== undefined) {
            urlParams.append('searchFilter', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.unpaidOnly : (params.unpaidOnly ?? queryDefaults?.['unpaidOnly']);
        if (value !== undefined) {
            urlParams.append('unpaidOnly', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.languageCode : (params.languageCode ?? queryDefaults?.['languageCode']);
        if (value !== undefined) {
            urlParams.append('languageCode', value.toString());
        }
    }
    {
        const value = queryDefaults === false
            ? params.combinedInvoiceType
            : (params.combinedInvoiceType ?? queryDefaults?.['combinedInvoiceType']);
        if (value !== undefined) {
            urlParams.append('combinedInvoiceType', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getInvoicesIncludingSelfbooking.paramsOrder = [{ type: 'parameters' }];
export const markPaymentAsDone = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.paymentId === undefined) {
        throw new Error('Missing required parameter: paymentId');
    }
    const path = '/api/ws-invoices/payments/{paymentId}/mark-as-done'.replaceAll('{paymentId}', () => encodeURIComponent(String(params.paymentId)));
    const pathInternal = '/api/payments/{paymentId}/mark-as-done'.replaceAll('{paymentId}', () => encodeURIComponent(String(params.paymentId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
markPaymentAsDone.paramsOrder = [{ type: 'parameters' }];
export const markPaymentAsOpen = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.paymentId === undefined) {
        throw new Error('Missing required parameter: paymentId');
    }
    const path = '/api/ws-invoices/payments/{paymentId}/mark-as-open'.replaceAll('{paymentId}', () => encodeURIComponent(String(params.paymentId)));
    const pathInternal = '/api/payments/{paymentId}/mark-as-open'.replaceAll('{paymentId}', () => encodeURIComponent(String(params.paymentId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
markPaymentAsOpen.paramsOrder = [{ type: 'parameters' }];
export const markPaymentAsCredit = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.paymentId === undefined) {
        throw new Error('Missing required parameter: paymentId');
    }
    const path = '/api/ws-invoices/payments/{paymentId}/mark-as-credit'.replaceAll('{paymentId}', () => encodeURIComponent(String(params.paymentId)));
    const pathInternal = '/api/payments/{paymentId}/mark-as-credit'.replaceAll('{paymentId}', () => encodeURIComponent(String(params.paymentId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
markPaymentAsCredit.paramsOrder = [{ type: 'parameters' }];
export const unmarkPaymentAsCredit = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.paymentId === undefined) {
        throw new Error('Missing required parameter: paymentId');
    }
    const path = '/api/ws-invoices/payments/{paymentId}/unmark-as-credit'.replaceAll('{paymentId}', () => encodeURIComponent(String(params.paymentId)));
    const pathInternal = '/api/payments/{paymentId}/unmark-as-credit'.replaceAll('{paymentId}', () => encodeURIComponent(String(params.paymentId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
unmarkPaymentAsCredit.paramsOrder = [{ type: 'parameters' }];
export const editPayment = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.paymentId === undefined) {
        throw new Error('Missing required parameter: paymentId');
    }
    if (params.paymentForm === undefined) {
        throw new Error('Missing required body: paymentForm');
    }
    const path = '/api/ws-invoices/payments/{paymentId}'.replaceAll('{paymentId}', () => encodeURIComponent(String(params.paymentId)));
    const pathInternal = '/api/payments/{paymentId}'.replaceAll('{paymentId}', () => encodeURIComponent(String(params.paymentId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.paymentForm !== undefined) {
        body = params.paymentForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
editPayment.paramsOrder = [{ type: 'body', paramName: 'paymentForm' }, { type: 'parameters' }];
/** Get company configs */ export const getCompanyConfigs = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-invoices/company-configs';
    const pathInternal = '/api/company-configs';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.searchFilter : (params.searchFilter ?? queryDefaults?.['searchFilter']);
        if (value !== undefined) {
            urlParams.append('searchFilter', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyConfigs.paramsOrder = [{ type: 'parameters' }];
/** Create new company config */ export const createCompanyConfig = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyConfigForm === undefined) {
        throw new Error('Missing required body: companyConfigForm');
    }
    const path = '/api/ws-invoices/company-configs';
    const pathInternal = '/api/company-configs';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.companyConfigForm !== undefined) {
        body = params.companyConfigForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createCompanyConfig.paramsOrder = [{ type: 'body', paramName: 'companyConfigForm' }];
/** Get company config by id */ export const getCompanyConfigById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyConfigId === undefined) {
        throw new Error('Missing required parameter: companyConfigId');
    }
    const path = '/api/ws-invoices/company-configs/{companyConfigId}'.replaceAll('{companyConfigId}', () => encodeURIComponent(String(params.companyConfigId)));
    const pathInternal = '/api/company-configs/{companyConfigId}'.replaceAll('{companyConfigId}', () => encodeURIComponent(String(params.companyConfigId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyConfigById.paramsOrder = [{ type: 'parameters' }];
/** Update company config */ export const updateCompanyConfig = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyConfigId === undefined) {
        throw new Error('Missing required parameter: companyConfigId');
    }
    if (params.companyConfigForm === undefined) {
        throw new Error('Missing required body: companyConfigForm');
    }
    const path = '/api/ws-invoices/company-configs/{companyConfigId}'.replaceAll('{companyConfigId}', () => encodeURIComponent(String(params.companyConfigId)));
    const pathInternal = '/api/company-configs/{companyConfigId}'.replaceAll('{companyConfigId}', () => encodeURIComponent(String(params.companyConfigId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.companyConfigForm !== undefined) {
        body = params.companyConfigForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateCompanyConfig.paramsOrder = [{ type: 'body', paramName: 'companyConfigForm' }, { type: 'parameters' }];
/** Get company config by company id */ export const getCompanyConfigByCompanyId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-invoices/company-configs/by-company-id';
    const pathInternal = '/api/company-configs/by-company-id';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyConfigByCompanyId.paramsOrder = [{ type: 'parameters' }];
/** Get company configs for current user */ export const getCompanyConfig = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-invoices/company-config';
    const pathInternal = '/api/company-config';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyConfig.paramsOrder = [];
export const isInvoiceReminderEnabled = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-invoices/company-config/invoice-reminder-enabled';
    const pathInternal = '/api/company-config/invoice-reminder-enabled';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
isInvoiceReminderEnabled.paramsOrder = [];
/** pingen webhooks callback */ export const pingenWebhookCallback = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.incomingForm === undefined) {
        throw new Error('Missing required body: incomingForm');
    }
    const path = '/api/ws-invoices/pingen/webhookCallback';
    const pathInternal = '/api/pingen/webhookCallback';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.incomingForm !== undefined) {
        body = params.incomingForm;
    }
    const headers = {};
    headers['Accept'] = 'text/plain';
    headers['Content-Type'] = 'application/json, application/vnd.api+json';
    if (params.signature !== undefined) {
        headers['signature'] = params.signature.toString();
    }
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'text',
        requestType: 'json',
    });
};
pingenWebhookCallback.paramsOrder = [{ type: 'body', paramName: 'incomingForm' }, { type: 'parameters' }];
/** Get paginated list of invoice id ranges */ export const getCustomInvoiceIdRanges = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-invoices/custom-invoice-id-ranges';
    const pathInternal = '/api/custom-invoice-id-ranges';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCustomInvoiceIdRanges.paramsOrder = [{ type: 'parameters' }];
/** Create a new custom invoice id range */ export const createCustomInvoiceIdRange = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-invoices/custom-invoice-id-ranges';
    const pathInternal = '/api/custom-invoice-id-ranges';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createCustomInvoiceIdRange.paramsOrder = [{ type: 'body', paramName: 'form' }];
/** Get invoice id range by id */ export const getCustomInvoiceIdRangeById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-invoices/custom-invoice-id-ranges/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/custom-invoice-id-ranges/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCustomInvoiceIdRangeById.paramsOrder = [{ type: 'parameters' }];
/** Update an invoice id range */ export const updateCustomInvoiceIdRange = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-invoices/custom-invoice-id-ranges/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/custom-invoice-id-ranges/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateCustomInvoiceIdRange.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** Delete an unused custom invoice id range */ export const deleteCustomInvoiceIdRange = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-invoices/custom-invoice-id-ranges/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/custom-invoice-id-ranges/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteCustomInvoiceIdRange.paramsOrder = [{ type: 'parameters' }];
/** Returns campaigns for reporting */ export const getReportingInvoicePositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-invoices/reporting/invoice-positions';
    const pathInternal = '/api/reporting/invoice-positions';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getReportingInvoicePositions.paramsOrder = [{ type: 'parameters' }];
/** Returns invoice positions for reporting using keyset pagination */ export const getReportingInvoicePositionsCursor = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.lastId === undefined) {
        throw new Error('Missing required parameter: lastId');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-invoices/reporting/invoice-positions/cursor';
    const pathInternal = '/api/reporting/invoice-positions/cursor';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.lastId !== undefined) {
        urlParams.append('lastId', params.lastId.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getReportingInvoicePositionsCursor.paramsOrder = [{ type: 'parameters' }];
export * from './types';
export * from './constants';
